"use strict";

import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { Model } from "Model";
import { Collection } from "Collection";
import { Messages } from "Messages";
import { showSnackBar } from "Actions/D5SnackbarsActions";
import { Fields, System } from "Constants/objects";
import Columns from "Stores/Table/core/table/Columns";
import { loadObjectData } from "D5Utils/common_requests";
import { UserScriptModel } from "UserActionHandler/UserScriptModel";
import Configurator from "Stores/Table/core/table/Configurator";
import { createGuid, createSelectFieldDS, formatDateToAPI, formatMessage, getAddSSFilter, isDateByTypeStr, isEmptyObject } from "D5Utils/functions";
import { tbButtonsToggleAttrs } from "Actions/Table/TableToolBarActions";
/**
 * @param {string} componentOperation
 * @return {string}
 */

function operationFactory(componentOperation) {
  var _System$FILTER_OPERAT = System.FILTER_OPERATIONS,
      contains = _System$FILTER_OPERAT.contains,
      isblank = _System$FILTER_OPERAT.isblank,
      isnotblank = _System$FILTER_OPERAT.isnotblank,
      isanyof = _System$FILTER_OPERAT.isanyof,
      isnotanyof = _System$FILTER_OPERAT.isnotanyof,
      notequal = _System$FILTER_OPERAT.notequal;

  switch (componentOperation) {
    case contains:
      return 'like';

    case notequal:
      return '!=';

    case isblank:
    case isanyof:
      return '=';

    case isnotblank:
    case isnotanyof:
      return '!=';

    default:
      return componentOperation;
  }
}

export var HeaderFilterDS =
/*#__PURE__*/
function () {
  /**
   * @param {string} dictObject
   * @param {string} dictKeyFld
   * @param {string} displayFld
   * @param {array}  filter
   */
  function HeaderFilterDS(dictObject, dictKeyFld, displayFld) {
    var filter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, HeaderFilterDS);

    this.dictObject = dictObject;
    this.dictKeyFld = dictKeyFld;
    this.displayFld = displayFld;
    this.filter = filter;
  }

  _createClass(HeaderFilterDS, [{
    key: "dataSource",
    value: function dataSource() {
      if (!(this.dictKeyFld && this.dictObject && this.displayFld)) return null;
      return createSelectFieldDS(this.dictObject, this.dictKeyFld, this.displayFld, this.filter);
    }
  }]);

  return HeaderFilterDS;
}();
export var TableDS =
/*#__PURE__*/
function () {
  /**
   * @param {Configurator} settings
   */
  function TableDS(settings) {
    _classCallCheck(this, TableDS);

    this.settings = settings;
  }

  _createClass(TableDS, [{
    key: "getTableData",
    value: function () {
      var _getTableData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(loadOptions) {
        var _this = this;

        var _this$settings, filtersData, objectName, requestColumns, formEvents, columnNames, keyField, viewSource, loadPanel, requestObject, validReqFilters;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$settings = this.settings, filtersData = _this$settings.filtersData, objectName = _this$settings.objectName, requestColumns = _this$settings.requestColumns, formEvents = _this$settings.formEvents, columnNames = _this$settings.columnNames, keyField = _this$settings.keyField, viewSource = _this$settings.viewSource, loadPanel = _this$settings.loadPanel;
                requestObject = {
                  Filters: this.prepareFilter(loadOptions),
                  Sorts: this.prepareSortData(loadOptions)
                };
                validReqFilters = this.checkRequiredFilters(requestObject.Filters); //это вроде работает только если обновляется таблица

                if (loadOptions.hasOwnProperty('totalSummary')) {
                  this.settings._totalRow.shouldUpdate();
                }

                return _context.abrupt("return", new Promise(function (resolve) {
                  loadPanel.show();

                  if (!validReqFilters || filtersData && !isEmptyObject(filtersData) && Object.values(filtersData)[0] == null) {
                    loadPanel.hide();
                    resolve([]);
                    return;
                  }

                  var TableModel = Model.extend({
                    object: objectName
                  });
                  var tableCollection = new (Collection.extend({
                    model: TableModel,
                    object: objectName
                  }))();
                  var page = (loadOptions.skip + loadOptions.take) / loadOptions.take || -1;

                  if (formEvents) {
                    var getDataEv = '';

                    if (typeof formEvents.OnBeforeGetData === "function") {
                      getDataEv = 'OnBeforeGetData';
                      console.warn(Messages.Warning.OnBeforeGetDataFilterDeprecated);
                    } else if (typeof formEvents.onBeforeGetData === "function") getDataEv = 'onBeforeGetData';

                    if (formEvents[getDataEv] === 'function') {
                      var formModel = new UserScriptModel(viewSource, {}, System.USER_SCRIPTS_INITIATOR.TABLE);
                      requestObject = formEvents[getDataEv]({
                        model: formModel,
                        requestObject: requestObject
                      });
                    }
                  }

                  tableCollection.fetch({
                    data: _objectSpread({}, requestObject, {
                      Page: loadOptions.isLoadingAll ? -1 : page,
                      RowsPerPage: loadOptions.take,
                      Columns: requestColumns
                    }),
                    success: function success(resp) {
                      _this.settings.additionalFilter = {};
                      Promise.all([TableDS.prepareSourceData({
                        data: resp.toJSON(),
                        columnNames: columnNames,
                        keyField: keyField,
                        viewSource: viewSource
                      }), _this.settings._totalRow.calcSummariesValues()]).then(function (data) {
                        loadPanel.hide();
                        resolve({
                          data: data[0],
                          summary: data[1]
                        });
                        setTimeout(function () {
                          _this.settings.resetSelection();
                        }, 160);
                      });
                    },
                    error: function error() {
                      loadPanel.hide();
                      resolve([]);
                    }
                  });
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTableData(_x) {
        return _getTableData.apply(this, arguments);
      }

      return getTableData;
    }()
  }, {
    key: "getDefaultOperation",
    value: function getDefaultOperation(type) {
      switch (type) {
        case 'string':
          return 'contains';

        default:
          return '=';
      }
    }
  }, {
    key: "prepareFilter",
    value: function prepareFilter(_ref) {
      var _this2 = this;

      var _ref$mode = _ref.mode,
          mode = _ref$mode === void 0 ? 'table' : _ref$mode;
      var outFilter = {};
      var _System$FILTER_OPERAT2 = System.FILTER_OPERATIONS,
          isblank = _System$FILTER_OPERAT2.isblank,
          isnotblank = _System$FILTER_OPERAT2.isnotblank,
          equal = _System$FILTER_OPERAT2.equal,
          between = _System$FILTER_OPERAT2.between;
      var grid = this.settings.instance();

      for (var i = 0; i < grid.columnCount(); ++i) {
        var col = grid.columnOption(i);
        var dataField = col.dataField;
        var field = this.settings.getFieldByName(dataField);
        var dataType = col.dataType;
        var operation = col.userData && col.userData.realOperation || this.getDefaultOperation(dataType);
        var value = void 0;
        if (!field) continue;

        if (dataType === 'boolean') {
          operation = equal;
          value = grid.columnOption(i, "filterValue");
          value = value != null ? Number(value) : undefined;
        } else if (isDateByTypeStr(dataType)) {
          value = grid.columnOption(i, "filterValue");

          if (Array.isArray(value)) {
            value = value.map(function (date) {
              return formatDateToAPI(new Date(date));
            });

            if (operation === between && dataType === System.FIELD_EDITOR_TYPE.DATETIME) {
              if (value[0] != null) {
                value[0] = value[0] + 'T00:00:00';
              }

              if (value[1] != null) {
                value[1] = value[1] + 'T23:59:59';
              }
            }
          } else {
            value = value != null ? formatDateToAPI(new Date(value)) : undefined;

            if (dataType === System.FIELD_EDITOR_TYPE.DATETIME && value != null) {
              //Если это дата c временем и выбрана операция равно, то нужно искать за весь день
              if (operation === equal) {
                operation = between;
                value = [value + 'T00:00:00', value + 'T23:59:59'];
              }
            }
          }
        } else {
          value = grid.columnOption(i, "filterValue");
        }

        if (operation !== isblank && operation !== isnotblank) {
          value = value == null || value === '' || Array.isArray(value) && !value.length ? undefined : value;
        } else {
          value = null;
        }

        var filterField = Columns.isLookup(field) ? field[Fields.KeyFilterField] : field[Fields.ObjectFieldID_Name];

        if (filterField && (Array.isArray(value) && value.length || !Array.isArray(value) && typeof value !== 'undefined')) {
          if (operation === between) {
            if (value[0] != null && value[1] == null) {
              operation = '>=';
              value = value[0];
            } else if (value[0] == null && value[1] != null) {
              operation = '<=';
              value = value[0];
            } else if (value[0] == null && value[1] == null) continue;
          }

          outFilter[filterField] = _defineProperty({}, Columns.isLookup(field) ? equal : operationFactory(operation), value);
        }
      }

      if (mode === 'table') {
        var lsKey = this.settings.getLSName();
        var addFilter = getAddSSFilter(lsKey);

        if (!isEmptyObject(addFilter)) {
          tbButtonsToggleAttrs([System.TOOLBAR_BTN_CLASSES.SEARCH], true, this.settings.formUUID);
        } else {
          tbButtonsToggleAttrs([System.TOOLBAR_BTN_CLASSES.SEARCH], false, this.settings.formUUID);
        }
        /**
         * param {string} key Fields.Name
         */


        _.each(addFilter, function (obj, key) {
          if (obj.hasOwnProperty('filterValue') && obj.hasOwnProperty('realOperation')) _this2.settings.additionalFilter[key] = _defineProperty({}, operationFactory(obj.realOperation), obj.filterValue);
        });
      }

      _.each(this.settings.additionalFilter, function (values, key) {
        outFilter[key] = values;
      });

      if (this.settings.filtersData) {
        var keysObj = Object.keys(this.settings.filtersData);

        _.each(keysObj, function (filter) {
          if (_this2.settings.filtersData[filter] && _this2.settings.filtersData[filter].toString().length) {
            outFilter[filter] = _this2.settings.filtersData[filter];
          }
        });
      }

      return outFilter;
    }
    /**
     * @param {array} sort
     *
     * Return's example
     *
     * ['Name']
     * ['-Name']
     *
     * @return {array}
     */

  }, {
    key: "prepareSortData",
    value: function prepareSortData(_ref2) {
      var _this3 = this;

      var sort = _ref2.sort;
      if (!Array.isArray(sort)) return [];
      return sort.map(function (item) {
        var field = _.find(_this3.settings.viewSource, function (view) {
          return view[Fields.Name] === item.selector;
        });

        var selector = field[Fields.ObjectFieldID_Name];
        return item.desc ? "-".concat(selector) : selector;
      });
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "checkRequiredFilters",
    value: function checkRequiredFilters() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var requiredFilterFields = this.settings.requiredFilterFields;
      var reqFilterFields = requiredFilterFields || [];
      return !reqFilterFields.some(function (item) {
        return !filter.hasOwnProperty(item) || filter[item] == null;
      });
    }
  }, {
    key: "dataSource",
    value: function dataSource() {
      var _this4 = this;

      var pageCount = 1;

      if (this.settings.isNestedObject()) {
        return this.settings.tableData;
      }

      return new DevExpress.data.DataSource({
        load: function load(loadOptions) {
          return _this4.getTableData(loadOptions, pageCount++);
        },
        pageSize: this.settings.config().pageSize,
        // reshapeOnPush: true,
        key: this.settings.systemKeyField,
        update: function update(key, values) {// . . .
        },
        remove: function remove() {},
        insert: function insert() {}
      });
    }
  }], [{
    key: "prepareSourceData",
    value: function () {
      var _prepareSourceData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(_ref3) {
        var data, viewSource, columnNames, keyField, _ref3$isNested, isNested, getFieldByName, additionalRequestToDict, out, promises, loadedDic, _loop, _i;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = _ref3.data, viewSource = _ref3.viewSource, columnNames = _ref3.columnNames, keyField = _ref3.keyField, _ref3$isNested = _ref3.isNested, isNested = _ref3$isNested === void 0 ? false : _ref3$isNested;

                getFieldByName = function getFieldByName(fieldName) {
                  return _.find(viewSource, function (item) {
                    return item[Fields.Name] === fieldName;
                  });
                };

                additionalRequestToDict = new Map();
                out = [];

                _.each(data, function (row) {
                  var obj = {};

                  _.each(columnNames, function (name) {
                    var field = getFieldByName(name);

                    if (Columns.isSystemField(field)) {
                      obj[name] = row[field[Fields.KeyFilterField]];
                    } else {
                      var val = row[field[Fields.ObjectFieldID_Name]];
                      obj[name] = val;
                      if (isDateByTypeStr(Columns.getColumnType(field)) && val) obj[name] = new Date(val);

                      if (isNested && Columns.isLookup(field) && val == null) {
                        var dictObject = field[Fields.ObjectFieldID_LinkedObjectID_Name],
                            dictKeyFld = field[Fields.ObjectFieldID_KeyObjectFieldID_Name],
                            dictDisplFld = field[Fields.ObjectFieldID_DisplayObjectFieldID_Name],
                            dickeyValue = row[field[Fields.KeyFilterField]];

                        if (dickeyValue != null) {
                          if (!additionalRequestToDict.has(dictObject)) {
                            additionalRequestToDict.set(dictObject, {
                              dictKeyFld: dictKeyFld,
                              columns: new Set([dictDisplFld]),
                              values: new Set([dickeyValue])
                            });
                          } else {
                            var dict = additionalRequestToDict.get(dictObject);
                            dict.columns.add(dictDisplFld);
                            dict.values.add(dickeyValue);
                            additionalRequestToDict.set(dictObject, dict);
                          }
                        }
                      }
                    }
                  });

                  obj[System.SYSTEM_PREFIX + keyField] = row[keyField] || createGuid();
                  out.push(obj);
                });

                if (!additionalRequestToDict.size) {
                  _context3.next = 13;
                  break;
                }

                promises = [];
                additionalRequestToDict.forEach(function (_ref4, objectName) {
                  var columns = _ref4.columns,
                      dictKeyFld = _ref4.dictKeyFld,
                      values = _ref4.values;
                  promises.push(_asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2() {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.t0 = objectName;
                            _context2.next = 3;
                            return loadObjectData({
                              columns: [].concat(_toConsumableArray(columns), [dictKeyFld]),
                              filter: _defineProperty({}, dictKeyFld, {
                                '=': _toConsumableArray(values)
                              }),
                              objectName: objectName
                            });

                          case 3:
                            _context2.t1 = _context2.sent;
                            return _context2.abrupt("return", {
                              objectName: _context2.t0,
                              data: _context2.t1
                            });

                          case 5:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }))());
                });
                _context3.next = 10;
                return Promise.all(promises);

              case 10:
                loadedDic = _context3.sent;

                _loop = function _loop() {
                  var row = out[_i];

                  var _loop2 = function _loop2(colName) {
                    if (row.hasOwnProperty(colName)) {
                      if (colName.indexOf(System.SYSTEM_PREFIX) === 0) return "continue";
                      var field = getFieldByName(colName);

                      if (Columns.isLookup(field) && row[colName] == null && row[System.SYSTEM_PREFIX + colName] != null) {
                        var dicName = field[Fields.ObjectFieldID_LinkedObjectID_Name],
                            dictDisplFld = field[Fields.ObjectFieldID_DisplayObjectFieldID_Name],
                            dictKeyFld = field[Fields.ObjectFieldID_KeyObjectFieldID_Name];
                        var dicData = loadedDic.find(function (dic) {
                          return dic.objectName === dicName;
                        });
                        dicData = dicData.data.find(function (data) {
                          return data[dictKeyFld] === row[System.SYSTEM_PREFIX + colName];
                        });
                        row[colName] = '';

                        if (dicData) {
                          row[colName] = dicData[dictDisplFld];
                        }
                      }
                    }
                  };

                  for (var colName in row) {
                    var _ret = _loop2(colName);

                    if (_ret === "continue") continue;
                  }
                };

                for (_i = 0; _i < out.length; _i++) {
                  _loop();
                }

              case 13:
                return _context3.abrupt("return", out);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function prepareSourceData(_x2) {
        return _prepareSourceData.apply(this, arguments);
      }

      return prepareSourceData;
    }()
  }]);

  return TableDS;
}();